import { createI18n } from 'vue-i18n';
import messages from '../locales';

let locale = localStorage.getItem('locale') || process.env.VUE_APP_I18N_DEFAULT_LOCALE;

localStorage.setItem('locale', locale);

export default createI18n({
    locale,
    fallbackLocale: process.env.VUE_APP_I18N_DEFAULT_FALLBACK_LOCALE,
    messages,
});
